import { LucideIcon } from "lucide-react";

export enum SidebarItemKind {
  Button = "BUTTON",
  Section = "SECTION",
  Group = "GROUP",
}

export type SidebarItem = SidebarButtonItem | SidebarSectionItem | SidebarGroupItem;

export type SidebarSubItem = SidebarButtonItem | SidebarGroupItem;

export type GenericSidebarItem<K extends SidebarItemKind> = {
  kind: K;
};

export type SidebarButtonItem = GenericSidebarItem<SidebarItemKind.Button> & {
  label: string;
  href: string;
  isActive: boolean;
  icon?: LucideIcon;
};

export enum SidebarGroupId {
  UtilitiesWebClipper = "utilities-web-clipper",
  UtilitiesSmart = "utilities-smart",
  UtilitiesImportsExports = "utilities-imports-exports",
  AdminBadges = "admin-badges",
}

export type SidebarGroupItem = GenericSidebarItem<SidebarItemKind.Group> & {
  id: SidebarGroupId;
  label: string;
  items: SidebarButtonItem[];
  icon?: LucideIcon;
};

export enum SidebarSectionId {
  Overview = "overview",
  Company = "company",
  Support = "support",
  Sync = "sync",
  Utilities = "utilities",
  Admin = "admin",
}

export type SidebarSectionItem = GenericSidebarItem<SidebarItemKind.Section> & {
  id: SidebarSectionId;
  label: string;
  items: SidebarSubItem[];
};
